import { EventInfoStatus, RecordedInterviewSystemStatus } from 'api-paths-cas';
import { UserRole } from '../../../store/auth/types';
import { ButtonProps } from '@chakra-ui/react';

export type Status = 'Disabled' | 'Available' | 'Locked';

export enum SectionInfoState {
  Conflict,
  Update,
  Pending,
  InProgress,
  Complete,
}

export interface SectionProps {
  id: string;
  label: string;
  subLabel?: string;
  description?: string;
  status: Status;
  isRisk?: boolean;
  isInactiveRisk?: boolean;
  completeness?: number;
  itemsComplete?: number;
  itemsRequired?: number;
  flags?: number;
  infoState?: SectionInfoState;
  calendlyInterviewsInfoStatus?: EventInfoStatus;
  recordedInterviewSystemStatus?: RecordedInterviewSystemStatus;
  userRole?: UserRole;
  isScheduledInterviewsVisible?: boolean;
  isRecordedInterviewVisible?: boolean;
  buttonProps?: ButtonProps;
}

export enum SectionId {
  CHECKLIST = 'CHECKLIST',
  GENERAL_DOC = 'GENERAL_DOC',
  FINANCE_DOC = 'FINANCE_DOC',
  PRE_CAS_INTERVIEW = 'PRE_CAS_INTERVIEW',
  VISA_PREP = 'VISA_PREP',
  CAS_DOC = 'CAS_DOC',
  COMPLETE = 'COMPLETE',
  ENROLMENT = 'ENROLMENT',
  FOLLOW_UP_DOCUMENTS = 'FOLLOW_UP_DOCUMENTS',
  PRE_DEPARTURE_DOCS = 'PRE_DEPARTURE_DOCS',
  AFTER_TRAVEL_DOCS = 'AFTER_TRAVEL_DOCS',
  SCHEDULED_INTERVIEWS = 'SCHEDULED_INTERVIEWS',
}
